"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _MarkdownHtml = _interopRequireDefault(require("./MarkdownHtml"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
var _TooltipIcon = _interopRequireDefault(require("./TooltipIcon"));
var _excluded = ["labelFor", "displayAfter", "labelStyle", "label", "labelComponent", "labelTooltip", "children", "style", "omitRequiredAsterisk", "required"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DisplayLabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputLabel__DisplayLabelContainer"
})(["font-size:", "rem;color:", ";", ";", ";", ";"], 14 / 16, function (props) {
  if (props.labelStyle === "light") {
    return "#FFF";
  } else if (props.labelStyle === "dark") {
    return "#111";
  } else if (props.labelStyle === "gray") {
    return "#333333";
  } else if (props.labelStyle === "black") {
    return "#000";
  } else {
    return "#395865";
  }
}, function (props) {
  return props.labelStyle === "achievement" && (0, _styledComponents.css)(["font-family:'Karla',Helvetica,Arial,sans-serif;text-transform:uppercase;color:#0c0c0c;"]);
}, function (props) {
  return props.displayAfter === true && (0, _styledComponents.css)(["width:100%;display:block;"]);
}, function (props) {
  return (props.readOnly || props.disabled) && (0, _styledComponents.css)(["cursor:default;opacity:0.5;"]);
});
var LabelText = _styledComponents["default"].div.withConfig({
  displayName: "InputLabel__LabelText"
})(["margin:0 0 -6px 0;display:", ";align-items:center;& span.field-info{display:flex;}"], function (props) {
  return props.hasTooltip ? 'flex' : 'block';
});
var Label = _styledComponents["default"].label.withConfig({
  displayName: "InputLabel__Label"
})(["display:block;position:relative;margin-bottom:8px;"]);
var InputLabel = function InputLabel(_ref) {
  var labelFor = _ref.labelFor,
    displayAfter = _ref.displayAfter,
    labelStyle = _ref.labelStyle,
    label = _ref.label,
    labelComponent = _ref.labelComponent,
    labelTooltip = _ref.labelTooltip,
    children = _ref.children,
    style = _ref.style,
    _ref$omitRequiredAste = _ref.omitRequiredAsterisk,
    omitRequiredAsterisk = _ref$omitRequiredAste === void 0 ? true : _ref$omitRequiredAste,
    required = _ref.required,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (label && label.length >= 1) {
    var hasTooltip = !!(labelTooltip !== null && labelTooltip !== void 0 && labelTooltip.content);
    var tooltipPlacement = (label === null || label === void 0 ? void 0 : label.length) > 20 ? 'bottom-end' : 'bottom-center';
    if (hasTooltip && labelTooltip !== null && labelTooltip !== void 0 && labelTooltip.placement) {
      tooltipPlacement = labelTooltip === null || labelTooltip === void 0 ? void 0 : labelTooltip.placement;
    }
    return /*#__PURE__*/_react["default"].createElement(Label, {
      htmlFor: labelFor || label
    }, displayAfter ? children : null, /*#__PURE__*/_react["default"].createElement(DisplayLabelContainer, rest, /*#__PURE__*/_react["default"].createElement(LabelText, {
      hasTooltip: hasTooltip
    }, labelComponent && labelComponent, /*#__PURE__*/_react["default"].createElement(_MarkdownHtml["default"], null, label), /*#__PURE__*/_react["default"].createElement("span", {
      className: "field-info"
    }, hasTooltip && /*#__PURE__*/_react["default"].createElement(_TooltipIcon["default"], {
      title: labelTooltip === null || labelTooltip === void 0 ? void 0 : labelTooltip.title,
      content: labelTooltip === null || labelTooltip === void 0 ? void 0 : labelTooltip.content,
      placement: tooltipPlacement
    })))), displayAfter ? null : children);
  } else {
    return children ? children : null;
  }
};
InputLabel.propTypes = {
  labelFor: _propTypes["default"].string,
  displayAfter: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles).isRequired,
  style: _propTypes["default"].object,
  required: _propTypes["default"].bool
};
InputLabel.defaultProps = {
  displayAfter: false,
  labelStyle: "light",
  style: {},
  label: "",
  required: false
};
var _default = exports["default"] = InputLabel;